<div
  class="max-w-360 mx-auto 2xl:px-0 px-d-32 bg-background-interactive-primary relative z-1 overflow-hidden md:-mb-29 mb-d-40 2xl:mx-auto md:mx-d-76 mx-d-20 md:rounded-48 rounded-3xl md:pt-d-44 pt-d-8 !px-d-0"
>
  <div
    class="bg-left-bottom bg-contain md:visible invisible bg-no-repeat flex justify-between md:px-d-80 px-d-20 md:pb-d-60 pb-d-24 pt-d-16"
    style="background-image: url(assets/footer/app-download-bg.webp);"
  >
    <div class="visible md:basis-3/5 md:space-y-d-24 space-y-d-36">
      <h1 class="text-title-lg-bold text-text-invert-primary">
        Compra tu plan en nuestra app y llévate <span class="text-text-primary">datos extra</span>
      </h1>
      <div class="flex gap-d-12 md:bg-transparent sm:justify-start justify-center bg-transparent md:p-d-0 px-d-20 py-d-18 rounded-24 my-d-18">
        <a href="https://apps.apple.com/us/app/virgin-mobile-colombia/id986364079?l=es&ls=1" class="cursor-pointer">
          <img
            src="assets/footer/apple-store.webp"
            alt="Descarga la aplicación de Virgin Mobile en la App Store de Apple"
            title="Descargar en App Store"
            draggable="false"
            loading="lazy"
            decoding="async"
            width="292"
            height="90"
            class="h-d-40 w-auto cursor-pointer"
          />
        </a>
        <a href="https://play.google.com/store/apps/details?id=com.virginmobile.colombia" class="cursor-pointer">
          <img
            src="assets/footer/google-play-store.webp"
            alt="Obtén la aplicación de Virgin Mobile en Google Play Store"
            title="Obtener en Google Play"
            draggable="false"
            loading="lazy"
            decoding="async"
            width="292"
            height="88"
            class="h-d-40 w-auto cursor-pointer"
          />
        </a>
      </div>
    </div>
    <div class="hidden w-45 md:flex flex-col justify-center items-center visible space-y-d-24">
      <img
        src="assets/footer/virgin-mobile-qr.webp"
        alt="Escanea el código QR para descargar la aplicación de Virgin Mobile"
        title="Código QR de la aplicación Virgin Mobile"
        loading="lazy"
        decoding="async"
        width="160"
        height="160"
        class="rounded-16"
      />
      <h1 class="text-subtitle-xs-bold text-text-invert-primary text-center">Escanea este código QR desde tu celular</h1>
    </div>
  </div>
</div>

<footer
  class="bg-background-invert-primary text-text-invert-primary pt-d-40 pb-25 md:pb-d-56 rounded-t-40 md:rounded-t-64 md:pt-45"
  role="contentinfo"
  aria-label="Virgin Mobile Site footer"
>
  <div class="max-w-360 mx-auto 2xl:px-0 px-d-32 flex md:flex-row flex-col space-x-d-32 px-d-20 md:px-d-80">
    <section class="footer-brand-column flex flex-col space-y-d-32 w-full md:w-1/3" aria-labelledby="brand-heading">
      <div class="flex flex-col space-y-d-24">
        <img
          src="assets/footer/virgin-mobile-logo.svg"
          alt="Virgin Mobile Colombia - Mobile Network Provider"
          title="Virgin Mobile Colombia Logo"
          loading="lazy"
          decoding="async"
          width="120"
          height="60"
          class="h-d-60 w-fit"
        />
        <h2 id="brand-heading" class="text-subtitle-lg-semibold text-text-invert-primary">Aquí compartes el 100% de tus datos.</h2>
      </div>
      <nav aria-label="Social media links">
        <div class="flex items-center space-x-d-16 text-text-invert-primary hover:text-text-interactive">
          <a
            data-key="Facebook"
            href="https://www.facebook.com/share/1aTdRjpH4S/?mibextid=wwXIfr"
            target="_blank"
            rel="noopener noreferrer"
            aria-label="Facebook"
            class="size-d-32 rounded-full flex items-center justify-center transition-colors"
          >
            <div class="flex items-center justify-center rounded-full size-d-32">
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32" class="size-d-32" style="color: #1877f2">
                <circle cx="16" cy="16" r="16" fill="currentColor"></circle>
                <path
                  fill="#fff"
                  d="m20.055 14.486-.265 2.228a.421.421 0 0 1-.421.374h-2.316v6.61a.299.299 0 0 1-.295.302h-2.36a.297.297 0 0 1-.274-.188.299.299 0 0 1-.02-.115l.012-6.609h-1.754a.42.42 0 0 1-.42-.42V14.44a.42.42 0 0 1 .42-.421h1.743v-2.16C14.105 9.36 15.592 8 17.768 8h1.784a.42.42 0 0 1 .42.421v1.876a.421.421 0 0 1-.42.42h-1.093c-1.183.02-1.406.586-1.406 1.432v1.864h2.591a.422.422 0 0 1 .41.473Z"
                ></path>
              </svg>
            </div>
          </a>
          <a
            data-key="LinkedIn"
            href="https://www.linkedin.com/company/virgin-mobile-latin-america/"
            target="_blank"
            rel="noopener noreferrer"
            aria-label="LinkedIn"
            class="size-d-32 rounded-full flex items-center justify-center transition-colors"
          >
            <div class="flex items-center justify-center rounded-full size-d-32">
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32" class="size-d-32" style="color: #0a66c2">
                <circle cx="16" cy="16" r="16" fill="currentColor"></circle>
                <path
                  fill="#fff"
                  d="M12.421 10.183a2.186 2.186 0 1 1-4.372.004 2.186 2.186 0 0 1 4.372-.004ZM11.387 13.278H9.088a.541.541 0 0 0-.54.54v9.64c0 .3.242.542.54.542h2.3a.541.541 0 0 0 .54-.541v-9.64a.541.541 0 0 0-.54-.541ZM23.947 18.836v4.667a.497.497 0 0 1-.497.497h-2.467a.496.496 0 0 1-.497-.497v-4.522c0-.676.196-2.947-1.764-2.947-1.52 0-1.83 1.562-1.895 2.263v5.217a.497.497 0 0 1-.492.486h-2.388a.496.496 0 0 1-.497-.497v-9.726a.497.497 0 0 1 .497-.499h2.388a.5.5 0 0 1 .507.499v.842c.564-.842 1.402-1.499 3.185-1.499 3.943-.002 3.92 3.688 3.92 5.716Z"
                ></path>
              </svg>
            </div>
          </a>
          <a
            data-key="Instagram"
            href="https://www.instagram.com/virginmobileco/"
            target="_blank"
            rel="noopener noreferrer"
            aria-label="Instagram"
            class="size-d-32 rounded-full flex items-center justify-center transition-colors"
          >
            <div class="flex items-center justify-center rounded-full size-d-32 bg-black p-1.5">
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32" class="size-d-32">
                <defs>
                  <linearGradient id="_r67R_0_" x1="16" x2="16" y1="31.853" y2="2.168" gradientUnits="userSpaceOnUse">
                    <stop stop-color="#E09B3D"></stop>
                    <stop offset=".24" stop-color="#C74C4D"></stop>
                    <stop offset=".65" stop-color="#C21975"></stop>
                    <stop offset="1" stop-color="#7024C4"></stop>
                  </linearGradient>
                </defs>
                <circle cx="16" cy="16" r="16" fill="url(#_r67R_0_)"></circle>
                <path
                  fill="#fff"
                  d="M19.234 8h-6.468A4.773 4.773 0 0 0 8 12.766v6.468A4.772 4.772 0 0 0 12.766 24h6.468A4.77 4.77 0 0 0 24 19.234v-6.468A4.773 4.773 0 0 0 19.234 8Zm3.158 11.234a3.158 3.158 0 0 1-3.158 3.158h-6.468a3.158 3.158 0 0 1-3.158-3.158v-6.468a3.158 3.158 0 0 1 3.158-3.158h6.468a3.158 3.158 0 0 1 3.158 3.158v6.468Z"
                ></path>
                <path
                  fill="#fff"
                  d="M16 11.863a4.14 4.14 0 1 0-.004 8.278A4.14 4.14 0 0 0 16 11.863Zm0 6.663a2.526 2.526 0 1 1 0-5.052 2.526 2.526 0 0 1 0 5.052ZM20.162 12.886a1.023 1.023 0 1 0 0-2.046 1.023 1.023 0 0 0 0 2.046Z"
                ></path>
              </svg>
            </div>
          </a>
          <a
            data-key="X (Twitter)"
            href="https://x.com/virgin_mobileco?s=11&amp;t=BHfliNhuASYiHXgRoZloyg"
            target="_blank"
            rel="noopener noreferrer"
            aria-label="X (Twitter)"
            class="size-d-32 rounded-full flex items-center justify-center transition-colors"
          >
            <div class="flex items-center justify-center rounded-full size-d-32 bg-black p-1.5">
              <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 32 32" class="size-d-32" style="color: #000">
                <path fill="#000" d="M0 16C0 7.163 7.163 0 16 0s16 7.163 16 16-7.163 16-16 16S0 24.837 0 16Z"></path>
                <path
                  fill="#fff"
                  d="M11.653 8.096H9.245l11.088 15.861h2.409L11.653 8.097Zm-4.542-1.18h5.294l4.59 6.68 5.746-6.68h1.569l-6.619 7.693 7.198 10.475h-5.294l-4.847-7.054-6.069 7.054H7.111l6.94-8.067-6.94-10.101Z"
                ></path>
              </svg>
            </div>
          </a>
        </div>
      </nav>
    </section>

    <nav class="footer-columns hidden md:flex gap-d-20 lg:gap-d-44 xl:gap-d-80 flex-1 w-full md:w-2/3" aria-label="Footer navigation">
      <div class="flex flex-col space-y-d-24">
        <section id="shop" class="space-y-d-8" style="order: 1">
          <h3 class="text-body-md-bold text-text-invert-primary">Tienda</h3>
          <ul class="space-y-d-4" role="list">
            <li>
              <a href="{{ NEW_SELFCARE_URL }}/planes-prepago/30-dias/" class="text-text-invert-primary text-body-sm-medium hover:text-text-interactive transition-colors">
                Planes
              </a>
            </li>
            <li>
              <a href="{{ NEW_SELFCARE_URL }}/bolsas" class="text-text-invert-primary text-body-sm-medium hover:text-text-interactive transition-colors">
                Bolsas
              </a>
            </li>
            <li>
              <a href="https://mi.virginmobile.co/marketplace" class="text-text-invert-primary text-body-sm-medium hover:text-text-interactive transition-colors">
                Marketplace
              </a>
            </li>
          </ul>
        </section>
        <section id="about-virgin-mobile" class="space-y-d-8" style="order: 2">
          <h3 class="text-body-md-bold text-text-invert-primary">Sobre Virgin Mobile</h3>
          <ul class="space-y-d-4" role="list">
            <li>
              <a href="{{ NEW_SELFCARE_URL }}/por-que-elegirnos" class="text-text-invert-primary text-body-sm-medium hover:text-text-interactive transition-colors">Por qué elegirnos</a>
            </li>
           <!--  <li>
              <a href="{{ NEW_SELFCARE_URL }}/quiero-ser-distribuidor" class="text-text-invert-primary text-body-sm-medium hover:text-text-interactive transition-colors">
                Conviértete en distribuidor
              </a>
            </li> -->
            <li>
              <a href="{{ NEW_SELFCARE_URL }}/legal" class="text-text-invert-primary text-body-sm-medium hover:text-text-interactive transition-colors">
                Legal
              </a>
            </li>
          </ul>
        </section>
      </div>

      <div class="flex flex-col space-y-d-24">
        <section id="manage-mobile" class="space-y-d-8" style="order: 5">
          <h3 class="text-body-md-bold text-text-invert-primary">Centro de ayuda</h3>
          <ul class="space-y-d-4" role="list">
            <li>
              <a href="{{ NEW_SELFCARE_URL }}/faqs" class="text-text-invert-primary text-body-sm-medium hover:text-text-interactive transition-colors">
               Preguntas frecuentes (FAQs)
              </a>
            </li>
            <li>
              <a href="https://mi.virginmobile.co/encuentranos" class="text-text-invert-primary text-body-sm-medium hover:text-text-interactive transition-colors">
                Puntos de recarga
              </a>
            </li>
            <li>
              <a href="{{ NEW_SELFCARE_URL }}/pqrs" class="text-text-invert-primary text-body-sm-medium hover:text-text-interactive transition-colors">PQRS</a>
            </li>
            <li>
              <a href="{{ NEW_SELFCARE_URL }}/atencion-al-cliente-virgin-mobile" class="text-text-invert-primary text-body-sm-medium hover:text-text-interactive transition-colors">
                Contáctanos
              </a>
            </li>
            <li>
              <a href="https://virginmobile.co/documents/terms-and-conditions.pdf" class="text-text-invert-primary text-body-sm-medium hover:text-text-interactive transition-colors">
                Términos y condiciones
              </a>
            </li>           
          </ul>
        </section>           

        <section id="manage-mobile" class="space-y-d-8" style="order: 5">
          <h3 class="text-body-md-bold text-text-invert-primary">Administra tu móvil</h3>
          <ul class="space-y-d-4" role="list">
            <li>
              <a href="/inicio/ingreso" class="text-text-invert-primary text-body-sm-medium hover:text-text-interactive transition-colors">Administra tu plan</a>
            </li>
            <li>
              <a href="/inicio/mi-cuenta/mis-equipos/registrar-equipo" class="text-text-invert-primary text-body-sm-medium hover:text-text-interactive transition-colors">
                Registra tu equipo
              </a>
            </li>
            <li>
              <a href="{{ NEW_SELFCARE_URL }}/estados-imei" class="text-text-invert-primary text-body-sm-medium hover:text-text-interactive transition-colors">
               Verifica estado IMEI / estado duplicado
              </a>
            </li>
            <li>
              <a href="{{ NEW_SELFCARE_URL }}/desbloquear-dispositivo" class="text-text-invert-primary text-body-sm-medium hover:text-text-interactive transition-colors">Desbloquear/bloquear tu equipo</a>
            </li>
            <li>
              <a href="{{ NEW_SELFCARE_URL }}/configurar-internet-movil" class="text-text-invert-primary text-body-sm-medium hover:text-text-interactive transition-colors">
                Configurar internet móvil
              </a>
            </li>            
          </ul>
        </section>
      </div>

      <div class="flex flex-col">
        <section id="payment-methods" class="space-y-d-8" style="order: 3">
          <h3 class="text-body-md-bold text-text-invert-primary">Información importante</h3>
          <ul class="space-y-d-4" role="list">
            <li>
              <a href="{{ NEW_SELFCARE_URL }}/mapa-de-cobertura" class="text-text-invert-primary text-body-sm-medium hover:text-text-interactive transition-colors">
                Mapa de cobertura
              </a>
            </li>
            <li>
              <a href="{{ NEW_SELFCARE_URL }}/tarifas" class="text-text-invert-primary text-body-sm-medium hover:text-text-interactive transition-colors">
                Comparación de planes y tarifas
              </a>
            </li>
            <li>
              <a href="{{ NEW_SELFCARE_URL }}/documents/factores-limitantes-velocidad-internet.pdf" class="text-text-invert-primary text-body-sm-medium hover:text-text-interactive transition-colors">
              Factores que pueden limitar la velocidad de Internet
              </a>
            </li>
            <li>
              <a href="{{ NEW_SELFCARE_URL }}/indicadores-de-calidad" class="text-text-invert-primary text-body-sm-medium hover:text-text-interactive transition-colors">
              Indicadores de calidad del servicio de Internet
              </a>
            </li>
            <li>
              <a href="{{ NEW_SELFCARE_URL }}/administracion-de-trafico" class="text-text-invert-primary text-body-sm-medium hover:text-text-interactive transition-colors">
                Prácticas de gestión de tráfico
              </a>
            </li> 
            <li>
              <a href="{{ NEW_SELFCARE_URL }}/legal/contra-abuso" class="text-text-invert-primary text-body-sm-medium hover:text-text-interactive transition-colors">
               Dignidad infantil

              </a>
            </li> 
            <li>
              <a href="{{ NEW_SELFCARE_URL }}/lealtad" class="text-text-invert-primary text-body-sm-medium hover:text-text-interactive transition-colors">
               Promociones de fidelización y retención
              </a>
            </li> 
            <li>
              <a href="{{ NEW_SELFCARE_URL }}/servicios-digitalizados" class="text-text-invert-primary text-body-sm-medium hover:text-text-interactive transition-colors">
              Trámites digitalizados
              </a>
            </li> 
          </ul>
        </section>
      </div>
    </nav>

    <nav class="flex md:hidden flex-col mt-d-32" aria-label="Mobile footer navigation">
      <input type="checkbox" id="footer-shop" class="footer-accordion-toggle" aria-expanded="false" aria-controls="footer-shop-content" />
      <label
        for="footer-shop"
        class="flex items-center justify-between py-d-8 cursor-pointer text-body-md-bold text-text-invert-primary hover:text-text-interactive transition-colors focus:outline-none focus:ring-2 focus:ring-border-interactive-primary focus:ring-offset-2"
      >
        <span>Tienda</span>
        <svg class="size-d-16 shrink-0 transition-transform duration-300" fill="none" stroke="currentColor" viewBox="0 0 24 24" aria-hidden="true">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 9l-7 7-7-7"></path>
        </svg>
      </label>
      <div id="footer-shop-content" class="footer-accordion-content max-h-0 overflow-hidden transition-all duration-300 ease-out" aria-hidden="true" inert>
        <ul class="flex flex-col space-y-d-12 pb-d-16">
          <li>
            <a href="{{ NEW_SELFCARE_URL }}/planes-prepago/30-dias" class="text-text-invert-primary text-body-sm-medium hover:text-text-interactive transition-colors block" tabindex="-1">
              Planes
            </a>
          </li>
          <li>
            <a href="{{ NEW_SELFCARE_URL }}/bolsas" class="text-text-invert-primary text-body-sm-medium hover:text-text-interactive transition-colors block" tabindex="-1">
              Bolsas
            </a>
          </li>
          <li>
            <a href="https://mi.virginmobile.co/marketplace" class="text-text-invert-primary text-body-sm-medium hover:text-text-interactive transition-colors block" tabindex="-1">
              Marketplace
            </a>
          </li>
        </ul>
      </div>

      <input type="checkbox" id="footer-help-centre" class="footer-accordion-toggle" aria-expanded="false" aria-controls="footer-help-centre-content" />
      <label
        for="footer-help-centre"
        class="flex items-center justify-between py-d-8 cursor-pointer text-body-md-bold text-text-invert-primary hover:text-text-interactive transition-colors focus:outline-none focus:ring-2 focus:ring-border-interactive-primary focus:ring-offset-2"
      >
        <span>Centro de ayuda</span>
        <svg class="size-d-16 shrink-0 transition-transform duration-300" fill="none" stroke="currentColor" viewBox="0 0 24 24" aria-hidden="true">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 9l-7 7-7-7"></path>
        </svg>
      </label>
      <div id="footer-help-centre-content" class="footer-accordion-content max-h-0 overflow-hidden transition-all duration-300 ease-out" aria-hidden="true" inert>
        <ul class="flex flex-col space-y-d-12 pb-d-16">
          <li>
            <a href="{{ NEW_SELFCARE_URL }}/faqs" class="text-text-invert-primary text-body-sm-medium hover:text-text-interactive transition-colors block" tabindex="-1">
              Preguntas frecuentes (FAQs)
            </a>
          </li>
          <li>
            <a href="https://mi.virginmobile.co/encuentranos" class="text-text-invert-primary text-body-sm-medium hover:text-text-interactive transition-colors block" tabindex="-1">
              Puntos de recarga            </a>
          </li>
          <li>
            <a href="{{ NEW_SELFCARE_URL }}/pqrs" class="text-text-invert-primary text-body-sm-medium hover:text-text-interactive transition-colors block" tabindex="-1">
              PQRS
            </a>
          </li>
          <li>
            <a href="{{ NEW_SELFCARE_URL }}/atencion-al-cliente-virgin-mobile" class="text-text-invert-primary text-body-sm-medium hover:text-text-interactive transition-colors block" tabindex="-1">
              Contáctanos
            </a>
          </li>
          <li>
            <a href="https://virginmobile.co/documents/terms-and-conditions.pdf" class="text-text-invert-primary text-body-sm-medium hover:text-text-interactive transition-colors block" tabindex="-1">
              Términos y condiciones
            </a>
          </li>
        </ul>
      </div>

      <input type="checkbox" id="footer-important-info" class="footer-accordion-toggle" aria-expanded="false" aria-controls="footer-important-info-content" />
      <label
        for="footer-important-info"
        class="flex items-center justify-between py-d-8 cursor-pointer text-body-md-bold text-text-invert-primary hover:text-text-interactive transition-colors focus:outline-none focus:ring-2 focus:ring-border-interactive-primary focus:ring-offset-2"
      >
        <span>Información importante</span>
        <svg class="size-d-16 shrink-0 transition-transform duration-300" fill="none" stroke="currentColor" viewBox="0 0 24 24" aria-hidden="true">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 9l-7 7-7-7"></path>
        </svg>
      </label>
      <div id="footer-important-info-content" class="footer-accordion-content max-h-0 overflow-hidden transition-all duration-300 ease-out" aria-hidden="true" inert>
        <ul class="flex flex-col space-y-d-12 pb-d-16">
          <li>
            <a href="{{ NEW_SELFCARE_URL }}/mapa-de-cobertura" class="text-text-invert-primary text-body-sm-medium hover:text-text-interactive transition-colors block" tabindex="-1">
              Mapa de cobertura
            </a>
          </li>
          <li>
            <a href="{{ NEW_SELFCARE_URL }}/tarifas" class="text-text-invert-primary text-body-sm-medium hover:text-text-interactive transition-colors block" tabindex="-1">
              Comparación de planes y tarifas
            </a>
          </li>
          <li>
            <a href="{{ NEW_SELFCARE_URL }}/documents/factores-limitantes-velocidad-internet.pdf" class="text-text-invert-primary text-body-sm-medium hover:text-text-interactive transition-colors block" tabindex="-1">
              Factores que pueden limitar la velocidad de Internet
            </a>
          </li>
          <li>
            <a href="{{ NEW_SELFCARE_URL }}/indicadores-de-calidad" class="text-text-invert-primary text-body-sm-medium hover:text-text-interactive transition-colors block" tabindex="-1">
              Indicadores de calidad del servicio de Internet
            </a>
          </li>
          <li>
            <a href="{{ NEW_SELFCARE_URL }}/administracion-de-trafico" class="text-text-invert-primary text-body-sm-medium hover:text-text-interactive transition-colors block" tabindex="-1">
              Prácticas de gestión de tráfico
            </a>
          </li>
          <li>
            <a href="{{ NEW_SELFCARE_URL }}/legal/contra-abuso" class="text-text-invert-primary text-body-sm-medium hover:text-text-interactive transition-colors block" tabindex="-1">
              Dignidad infantil
            </a>
          </li>
          <li>
            <a href="{{ NEW_SELFCARE_URL }}/lealtad" class="text-text-invert-primary text-body-sm-medium hover:text-text-interactive transition-colors block" tabindex="-1">
              Promociones de fidelización y retención
            </a>
          </li>
          <li>
            <a href="{{ NEW_SELFCARE_URL }}/servicios-digitalizados" class="text-text-invert-primary text-body-sm-medium hover:text-text-interactive transition-colors block" tabindex="-1">
              Trámites digitalizados
            </a>
          </li>
        </ul>
      </div>

      <input type="checkbox" id="footer-about-virgin-mobile" class="footer-accordion-toggle" aria-expanded="false" aria-controls="footer-about-virgin-mobile-content" />
      <label
        for="footer-about-virgin-mobile"
        class="flex items-center justify-between py-d-8 cursor-pointer text-body-md-bold text-text-invert-primary hover:text-text-interactive transition-colors focus:outline-none focus:ring-2 focus:ring-border-interactive-primary focus:ring-offset-2"
      >
        <span>Sobre Virgin Mobile</span>
        <svg class="size-d-16 shrink-0 transition-transform duration-300" fill="none" stroke="currentColor" viewBox="0 0 24 24" aria-hidden="true">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 9l-7 7-7-7"></path>
        </svg>
      </label>
      <div id="footer-about-virgin-mobile-content" class="footer-accordion-content max-h-0 overflow-hidden transition-all duration-300 ease-out" aria-hidden="true" inert>
        <ul class="flex flex-col space-y-d-12 pb-d-16">
          <li>
            <a href="{{ NEW_SELFCARE_URL }}/por-que-elegirnos" class="text-text-invert-primary text-body-sm-medium hover:text-text-interactive transition-colors block" tabindex="-1">
              Por qué elegirnos
            </a>
          </li>
         <!--  <li>
            <a href="{{ NEW_SELFCARE_URL }}/quiero-ser-distribuidor" class="text-text-invert-primary text-body-sm-medium hover:text-text-interactive transition-colors block" tabindex="-1">
              Conviértete en distribuidor
            </a>
          </li> -->
          <li>
            <a href="{{ NEW_SELFCARE_URL }}/legal" class="text-text-invert-primary text-body-sm-medium hover:text-text-interactive transition-colors block" tabindex="-1">
              Legal
            </a>
          </li>
        </ul>
      </div>

      <input type="checkbox" id="footer-manage-mobile" class="footer-accordion-toggle" aria-expanded="false" aria-controls="footer-manage-mobile-content" />
      <label
        for="footer-manage-mobile"
        class="flex items-center justify-between py-d-8 cursor-pointer text-body-md-bold text-text-invert-primary hover:text-text-interactive transition-colors focus:outline-none focus:ring-2 focus:ring-border-interactive-primary focus:ring-offset-2"
      >
        <span>Administra tu móvil</span>
        <svg class="size-d-16 shrink-0 transition-transform duration-300" fill="none" stroke="currentColor" viewBox="0 0 24 24" aria-hidden="true">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 9l-7 7-7-7"></path>
        </svg>
      </label>
      <div id="footer-manage-mobile-content" class="footer-accordion-content max-h-0 overflow-hidden transition-all duration-300 ease-out" aria-hidden="true" inert>
        <ul class="flex flex-col space-y-d-12 pb-d-16">
          <li>
            <a href="/inicio/ingreso" class="text-text-invert-primary text-body-sm-medium hover:text-text-interactive transition-colors block" tabindex="-1">
              Administra tu plan
            </a>
          </li>
          <li>
            <a href="/inicio/mi-cuenta/mis-equipos/registrar-equipo" class="text-text-invert-primary text-body-sm-medium hover:text-text-interactive transition-colors block" tabindex="-1">
              Registra tu equipo
            </a>
          </li>
          <li>
            <a href="{{ NEW_SELFCARE_URL }}/estados-imei" class="text-text-invert-primary text-body-sm-medium hover:text-text-interactive transition-colors block" tabindex="-1">
              Verifica estado IMEI / estado duplicado
            </a>
          </li>
          <li>
            <a href="{{ NEW_SELFCARE_URL }}/desbloquear-dispositivo" class="text-text-invert-primary text-body-sm-medium hover:text-text-interactive transition-colors block" tabindex="-1">
              Desbloquear/bloquear tu equipo
            </a>
          </li>
          <li>
            <a href="{{ NEW_SELFCARE_URL }}/configurar-internet-movil" class="text-text-invert-primary text-body-sm-medium hover:text-text-interactive transition-colors block" tabindex="-1">
              Configurar internet móvil
            </a>
          </li>
        </ul>
      </div>
    </nav>
  </div>
</footer>
